<template>
  <nodeWrapper>
    <div :class="['node-card-box']">
      <div
        :style="{ backgroundColor: getCurrentNodeContent.color }"
        class="title"
      >
        <span :style="headerNameStyle">{{
          config.customName || getCurrentNodeContent.cName
        }}</span>
        <div>
          <span class="extra-title">
            <slot name="title" />
          </span>
          <i
            v-show="isDelete"
            :class="['el-icon-close', 'close', 'ml16',isDisabled]"
            @click="$emit('onDelete')"
          />
        </div>
      </div>
      <div class="content" @click="handleEdit">
        <div class="text">
          <span v-if="!config.content" class="placeholder"
            >请选择{{ getCurrentNodeContent.cName }}</span
          >
          <QSClampLines :text="config.content" :lines="2" />
        </div>
        <i v-if="isArrow" class="arrow el-icon-arrow-right" />
      </div>
    </div>
    <slot>
      <addNode :isDisabled="isDisabled" v-bind="$attrs" v-on="$listeners" />
    </slot>
  </nodeWrapper>
</template>

<script>
import nodeWrapper from './nodeWrapper'
import addNode from './addNode'
import { config } from '../../config'
import { getType } from '../utils'
import mixin from '../../../mixins/auditFlowManage'

const { typeMap } = config
export default {
  name: 'nodeCard',
  mixins: [mixin],
  components: {
    nodeWrapper,
    addNode,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    isDelete: {
      type: Boolean,
      default: true,
    },
    isArrow: {
      type: Boolean,
      default: true,
    },
    headerNameStyle: {
      type: Object,
      default: () => ({}),
    },
    isDisabled: {
      type: String,
      default: '',
    },
  },
  computed: {
    getCurrentNodeContent() {
      const nodeInfoObj = {}
      const { actionType = '' } = this.config
      // 审批类型处理
      const type = getType(actionType)
      if (type && typeMap[type]) {
        return typeMap[type]
      }
      return nodeInfoObj
    },
  },
  methods: {
    handleEdit() {
      if (this.isArrow) {
        this.$emit('onEdit')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.node-card-box:after {
  pointer-events: none;
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  border-radius: 2px;
  border: 1px solid transparent;
  transition: all 0.3s;
}

.node-card-box {
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  width: 200px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background: #fff;
  border-radius: 2px;
  cursor: pointer;
  box-shadow: 0px 0px 4px 0px rgba(10, 42, 97, 0.2);
  transition: all 0.3s;

  .title {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    color: #fff;
    background: #1a4da0;
    border-radius: 2px 2px 0px 0px;
    .close {
      display: none;
      color: #646566;
    }
  }
  .content {
    position: relative;
    padding: 8px 36px 8px 8px;
    .text {
      line-height: 20px;
    }
  }

  .placeholder {
    color: #c8c9cc;
  }
  &:hover {
    .close {
      display: inline-block;
      color: #646566;
    }
    .extra-title {
      display: none;
    }
  }
}
.node-card-box .content .arrow {
  position: absolute;
  right: 0;
  top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #969799;
}
</style>

